export const SELF_SERVICE_RELEASE_LOCAL_STORAGE_KEY =
  '@cognite/apm/self-service-release';
